// Function to handle modal opening
export const modalHandler = (modal = "main-modal") => {
  document.querySelector(`[data-modal-target=${modal}]`).click();
};
